import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { useDepartment, Department } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<Department>
    useData={useDepartment}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
